import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from '../models/users';
import { NewItem } from '../models/new-item';
import { AuthService } from '../services/auth.service';
import { ItemsService } from '../services/items.service';
import { CommonModule } from '@angular/common';
import { SimpleCardComponent } from '../simple-card/simple-card.component';
import { Subscription } from 'rxjs';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-my-items',
    templateUrl: './my-items.component.html',
    styleUrls: ['./my-items.component.css'],
    standalone: true,
    imports: [CommonModule, SimpleCardComponent, RouterLink]
})
export class MyItemsComponent implements OnInit, OnDestroy {
  user: User | null = null;
  allItems: NewItem[] = [];
  collectionItems: NewItem[] = [];
  marketplaceItems: NewItem[] = [];
  activeTab: 'all' | 'collection' | 'selling' = 'all';
  loading: boolean = true;

  private userSubscription: Subscription | undefined;
  private itemsSubscription: Subscription | undefined;

  constructor(private itemsService: ItemsService, private authService: AuthService) {}

  ngOnInit(): void {
    this.userSubscription = this.authService.user$.subscribe(user => {
      this.user = user;
      if (this.user) {
        this.getMyItems();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.itemsSubscription) {
      this.itemsSubscription.unsubscribe();
    }
  }

  public getMyItems() {
    this.loading = true;
    this.itemsSubscription = this.itemsService.getMyItems().subscribe({
      next: (items) => {
        this.allItems = items;
        this.collectionItems = items.filter(i => !i.selling);
        this.marketplaceItems = items.filter(i => i.selling);
        this.loading = false;
      },
      error: (err) => {
        console.error("Error fetching items", err);
        this.loading = false;
      }
    });
  }

  public setTab(tab: 'all' | 'collection' | 'selling') {
    this.activeTab = tab;
  }
}
